export const saloonImageOptions = {
  angle: 'saloon',
  staticOptions: {
    Floorboard: 1,
    Fabric: 1,
    BeautyBox: 1,
    PouffeBase: 1,
    PouffeFabric: 1,
    CupboardsOwnersCabin: 1,
    SplitBerth: 1,
    Backrest: 1,
    TableBox: 1,
    CupboardsAftCabin: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: 'BeautyBox'
    },
    {
      option: 'Fabric',
      dependency: 'Veneer'
    },
    {
      option: 'PouffeBase',
      dependency: 'Veneer'
    },
    {
      option: 'PouffeFabric',
      dependency: 'Fabric'
    },
    {
      option: 'Backrest',
      dependency: 'Fabric'
    },
    {
      option: 'TableBox',
      dependency: 'Veneer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X49MK2/views/saloon.js